import { render } from "./SectionEighteen.vue?vue&type=template&id=6532449a&scoped=true"
import script from "./SectionEighteen.vue?vue&type=script&lang=js"
export * from "./SectionEighteen.vue?vue&type=script&lang=js"

import "./SectionEighteen.vue?vue&type=style&index=0&id=6532449a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6532449a"]])

export default __exports__